// Local service imports (not re-exported intentionally)
import {
  type IAppHubService,
  AppHubService,
  AppHubServiceToken,
} from './AppHubService';
import {
  type IClientStateReducerProvider,
  ClientStateReducerProvider,
  ClientStateReducerProviderToken,
} from './ClientStateReducerProvider';
import {
  type IConsentService,
  ConsentService,
  ConsentServiceToken,
} from './ConsentService';
import {
  type IElectronicIdHubService,
  ElectronicIdHubService,
  ElectronicIdHubServiceToken,
} from './ElectronicIdHubService';
import {
  type IElectronicIdService,
  ElectronicIdService,
  ElectronicIdServiceToken,
} from './ElectronicIdService';
import {
  type IFormSubmitService,
  FormSubmitService,
  FormSubmitServiceToken,
} from './FormSubmitService';
import {
  type IInitialStateService,
  InitialStateService,
  InitialStateServiceToken,
} from './InitialStateService';
import {
  type IPasswordService,
  PasswordService,
  PasswordServiceToken,
} from './PasswordService';
import { ServicesProvider } from './ServicesProvider';
import {
  type IWindowLocationService,
  WindowLocationService,
  WindowLocationServiceToken,
} from './WindowLocationService';

export function populateServices() {
  ServicesProvider.addService<IInitialStateService>(
    InitialStateServiceToken,
    InitialStateService,
  );
  ServicesProvider.addService<IAppHubService>(
    AppHubServiceToken,
    AppHubService,
  );
  ServicesProvider.addService<IConsentService>(
    ConsentServiceToken,
    ConsentService,
  );
  ServicesProvider.addService<IElectronicIdHubService<unknown>>(
    ElectronicIdHubServiceToken,
    ElectronicIdHubService,
  );
  ServicesProvider.addService<IElectronicIdService>(
    ElectronicIdServiceToken,
    ElectronicIdService,
  );
  ServicesProvider.addService<IFormSubmitService>(
    FormSubmitServiceToken,
    FormSubmitService,
  );
  ServicesProvider.addService<IPasswordService>(
    PasswordServiceToken,
    PasswordService,
  );
  ServicesProvider.addService<IWindowLocationService>(
    WindowLocationServiceToken,
    WindowLocationService,
  );
  ServicesProvider.addService<IClientStateReducerProvider>(
    ClientStateReducerProviderToken,
    ClientStateReducerProvider,
  );
}

// Intentionally do not export anything other than populateServices from this index.
